export default __webpack_public_path__ + "static/media/headingsIcon.68cff625.svg";